import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
import { validateButton } from '../rich-assets/button.js';
import { validateDatePicker } from '../rich-assets/date-picker.js';
import { validateDocument } from '../rich-assets/document.js';
import { validateLocation } from '../rich-assets/location.js';
import { validatePng } from '../rich-assets/png.js';
import { validateSecure } from '../rich-assets/secure.js';
import { validateSelection } from '../rich-assets/selection.js';
import { validateTimePicker } from '../rich-assets/time-picker.js';
import { validateVideo } from '../rich-assets/video.js';
import { validateWebView } from '../rich-assets/web-view.js';
export function validateRichAssets(node, nodeFields, pifFileSummary, accept) {
    const { idField, nodeTypeField, nextNodesField, richAssetField } = nodeFields;
    // rich asset is only for decision nodes
    if (nodeTypeField?.nodeType?.value !== 'D' || !richAssetField)
        return;
    if (ast.isRichAssetPng(richAssetField?.content)) {
        validatePng(nodeFields, pifFileSummary, accept);
    }
    else if (ast.isRichAssetButton(richAssetField?.content)) {
        validateButton(nodeFields, pifFileSummary, accept);
    }
    else if (ast.isRichAssetDatePicker(richAssetField?.content)) {
        validateDatePicker(nodeFields, accept);
    }
    else if (ast.isRichAssetDocument(richAssetField?.content)) {
        validateDocument(nodeFields, accept);
    }
    else if (ast.isRichAssetLocation(richAssetField?.content)) {
        validateLocation(nodeFields, accept);
    }
    else if (ast.isRichAssetSecure(richAssetField?.content)) {
        validateSecure(nodeFields, accept);
    }
    else if (ast.isRichAssetSelection(richAssetField?.content)) {
        validateSelection(nodeFields, pifFileSummary, accept);
    }
    else if (ast.isRichAssetTimePicker(richAssetField?.content)) {
        validateTimePicker(nodeFields, accept);
    }
    else if (ast.isRichAssetVideo(richAssetField?.content)) {
        validateVideo(nodeFields, accept);
    }
    else if (ast.isRichAssetWebView(richAssetField?.content)) {
        validateWebView(nodeFields, accept);
    }
    else if (ast.isRichAssetButtons(richAssetField?.content) &&
        ast.isButtonsJson(richAssetField.content.value)) {
        // Check if we have next nodes defined
        const hasNextNodes = nextNodesField && nextNodesField.nextNodes.length > 0;
        // If we have no next nodes defined, then iterate through all the
        // button options and verify that each of them has the dest property
        if (!hasNextNodes) {
            let hasOptionWithNoDest = false;
            const buttonsJson = richAssetField.content.value;
            const buttonOptionsArrayProperty = buttonsJson.properties.find((prop) => ast.isButtonOptionsArrayProperty(prop));
            buttonOptionsArrayProperty?.options?.forEach((option) => {
                const destProperty = option.properties.find((prop) => ast.isDestProperty(prop));
                if (!destProperty) {
                    hasOptionWithNoDest = true;
                }
            });
            if (hasOptionWithNoDest) {
                accept('error', `Since next nodes is not specified for node '${node.name}', each option in the buttons must have a dest property.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node.name,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
        }
    }
}
//# sourceMappingURL=validate-rich-assets.js.map